export const aboutStyles = {
	container: {
		maxWidth: 500
	},
	heading: {
		color: 'white',
		textAlign: 'center',
		marginBottom: 30,
		marginTop: 70
	},
	responsive_heading: {
		color: 'white',
		textAlign: 'center',
		marginBottom: 30
	},
	text: {
		fontFamily: 'Nunito',
		color: 'white'
	},
	cardImg: {
		maxWidth: 600,
		maxHeight: 500,
		marginTop: 50
	},
	heading2: {
		fontSize: 20,
		marginBottom: 15,
		marginTop: 30,
		fontWeight: 'bold'
	},
	headText: {
		fontSize: 15,
		lineHeight: 1
	}
};